import { B as q1, a as J1, C as Y1, D as D1, L as O1, M as A1, R as G1, T as X1, V as Q1 } from "./TableOfContents-KQebWtyU.mjs";
import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { useRef as k, useImperativeHandle as x, useState as w, useEffect as g, createElement as I, useCallback as b } from "react";
import d from "clsx";
import v from "animejs";
import H from "next/link";
import { useCurrentLocale as R } from "next-i18n-router/client";
import { i18nConfig as V } from "./lib.js";
import "./Content-DQidYhT2.mjs";
import { g as j } from "./getUrlWithLocale-Sb9sJa1R.mjs";
import "date-fns";
import "date-fns/locale";
import "next/headers";
import "./_baseToString-CcsvGzgN.mjs";
const M = "Input-module_inputWrapper__TYJbS", W = "Input-module_withIcon__ToU6Q", S = "Input-module_input__505b7", E = "Input-module_icon__qkecR", C = {
  inputWrapper: M,
  withIcon: W,
  input: S,
  icon: E
};
function F(e) {
  return /* @__PURE__ */ p("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ o(
      "path",
      {
        d: "M11.059 18.118C14.9576 18.118 18.118 14.9576 18.118 11.059C18.118 7.16042 14.9576 4 11.059 4C7.16042 4 4 7.16042 4 11.059C4 14.9576 7.16042 18.118 11.059 18.118Z",
        stroke: "#1E1F1E",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ o("path", { d: "M20.0721 20.0718L16.1221 16.1218", stroke: "#1E1F1E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function E1({ hasIcon: e = !1, className: r, placeholder: t, ...s }, c) {
  const n = k(null);
  return x(c, () => n.current), /* @__PURE__ */ p("div", { className: d(C.inputWrapper, e && C.withIcon), children: [
    /* @__PURE__ */ o("input", { ref: n, className: d(C.input, r), placeholder: t, ...s }),
    e && /* @__PURE__ */ o("span", { className: C.icon, children: /* @__PURE__ */ o(F, {}) })
  ] });
}
const N = "FormControl-module_wrapper__YTIL9", U = "FormControl-module_hasError__Esjds", B = "FormControl-module_error__fuU0f", P = "FormControl-module_hint__OYj42", $ = "FormControl-module_activeHint__wcVJK", Z = "FormControl-module_title__TRovM", _ = {
  wrapper: N,
  hasError: U,
  error: B,
  hint: P,
  activeHint: $,
  title: Z
};
function F1({ title: e, children: r, error: t, hint: s, htmlFor: c, activeHint: n, className: a }) {
  return /* @__PURE__ */ p("div", { className: d(_.wrapper, "text", !!t && _.hasError, a), children: [
    !!e && /* @__PURE__ */ o("label", { htmlFor: c, className: d(_.title, "h3"), children: e }),
    r,
    !!s && /* @__PURE__ */ o("div", { className: d(_.hint, n && _.activeHint, "text-sm"), children: s }),
    !!t && /* @__PURE__ */ o("div", { className: d(_.error, "text-sm"), children: t })
  ] });
}
function N1({
  className: e,
  enabled: r = !0,
  delay: t = 500,
  rotate: s = 0,
  text: c,
  white: n,
  purple: a,
  children: l
}) {
  const [i, m] = w(r), h = k(null);
  return g(() => {
    const u = setTimeout(() => {
      m((T) => T || r);
    }, t);
    return () => clearTimeout(u);
  }, [r, t]), g(() => {
    const u = h.current;
    if (u && i)
      return u.style.opacity = "0", v({
        targets: u,
        easing: "spring(1, 100, 10, 0)",
        scale: 1,
        opacity: 1,
        delay: t
      }), () => {
        v.remove(u);
      };
  }, [i, h, t, s]), /* @__PURE__ */ o(
    "span",
    {
      ref: h,
      style: {
        display: "inline-flex",
        opacity: 0,
        transformOrigin: "left",
        willChange: "opacity",
        transform: `rotate(${s}deg) scale(1.5)`
      },
      className: d(e, "stuffing", {
        "stuffing-white": n,
        "stuffing-purple": a,
        "stuffing-orange": !n && !a
      }),
      children: l || c
    }
  );
}
function U1({ href: e, locale: r, children: t, ...s }, c) {
  const n = k(null), a = R(V), l = r || a, i = typeof e == "string" ? e : e ? `${e.pathname || ""}${e.query ? `?${new URLSearchParams(e.query).toString()}` : ""}` : "", m = i ? j(i, l) : "";
  return x(c, () => n.current), /* @__PURE__ */ o(H, { href: m, locale: l, prefetch: !1, ...s, ref: n, children: t });
}
const q = "Text-module_text__XXjeA", J = "Text-module_xs__cPxPp", Y = "Text-module_sm__fl9vD", D = "Text-module_md__kiT9j", O = "Text-module_lg__nPLfy", A = "Text-module_left__mLCig", G = "Text-module_center__tNTJk", X = "Text-module_right__WlaBU", Q = "Text-module_overflow__mfOvl", z = "Text-module_lighter__Ac1E0", K = "Text-module_normal__8e8-I", e1 = "Text-module_bold__ZRBJh", t1 = "Text-module_bolder__TDnBT", o1 = "Text-module_inherit__3m48G", r1 = "Text-module_white__CcYJW", n1 = "Text-module_info__ABlmk", s1 = "Text-module_dark__apstj", i1 = "Text-module_darkLight__zci2U", c1 = "Text-module_secondary__21S6G", l1 = "Text-module_secondaryLight__ZtnRi", a1 = "Text-module_warning__uRHSW", d1 = "Text-module_error__efqQU", u1 = "Text-module_primary__nfG7f", p1 = "Text-module_success__qYdpb", L = {
  text: q,
  xs: J,
  sm: Y,
  md: D,
  lg: O,
  left: A,
  center: G,
  right: X,
  overflow: Q,
  lighter: z,
  normal: K,
  bold: e1,
  bolder: t1,
  inherit: o1,
  white: r1,
  info: n1,
  dark: s1,
  darkLight: i1,
  secondary: c1,
  secondaryLight: l1,
  warning: a1,
  error: d1,
  primary: u1,
  success: p1
};
function B1({ as: e = "p", children: r, overflow: t, className: s, weight: c = "normal", color: n, size: a = "md", textAlign: l, ...i }, m) {
  const h = k(null);
  x(m, () => h.current);
  const u = d(
    L.text,
    L[a],
    L[c],
    t && L.overflow,
    l && L[l],
    n && L[n],
    s
  );
  return I(e, { className: u, ref: h, ...i }, r);
}
const m1 = ({ width: e = 24, height: r = 25, fill: t = "currentColor" }) => /* @__PURE__ */ p("svg", { width: e, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.8125H16.504C18.987 3.8125 21 5.8255 21 8.3085V17.3175C21 19.7995 18.987 21.8125 16.504 21.8125H7.496C5.013 21.8125 3 19.7995 3 17.3165V8.3125C3 5.8275 5.015 3.8125 7.5 3.8125V3.8125Z",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ o("path", { d: "M11.0996 13.7129H16.4996", stroke: t, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M16.5004 9.21289H15.5554C14.0894 9.21289 12.9004 10.4019 12.9004 11.8679V12.8129V21.8129",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), h1 = ({ width: e = 24, height: r = 25, fill: t = "currentColor" }) => /* @__PURE__ */ p("svg", { width: e, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.8125H16.504C18.987 3.8125 21 5.8255 21 8.3085V17.3175C21 19.7995 18.987 21.8125 16.504 21.8125H7.496C5.013 21.8125 3 19.7995 3 17.3165V8.3125C3 5.8275 5.015 3.8125 7.5 3.8125V3.8125Z",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M16.2832 16.792L12.9309 12.035L12.5525 11.497L10.1542 8.09365L10.1047 8.02366C10.0109 7.89123 9.85878 7.8125 9.69653 7.8125H7.9727C7.56768 7.8125 7.33072 8.26885 7.56372 8.60014L7.72748 8.83298L10.9145 13.3574L11.2929 13.8955L13.8547 17.5313L13.9042 17.6013C13.9979 17.7338 14.1501 17.8125 14.3123 17.8125H16.0375C16.4423 17.8125 16.6793 17.3567 16.4469 17.0253L16.2832 16.792ZM14.6647 17.1599C14.5021 17.1599 14.3497 17.0809 14.256 16.948L11.7442 13.3835L11.3658 12.8455L8.2782 8.46332H9.34773C9.51031 8.46332 9.66275 8.54237 9.75642 8.67527L12.1048 12.0072L12.4832 12.5452L15.7342 17.1599H14.6647Z",
      fill: t
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M11.0989 13.1508C11.2353 12.9953 11.4812 13.0086 11.6002 13.1777C11.6852 13.2985 11.6762 13.4618 11.5786 13.5727L11.2956 13.894L7.94441 17.7044C7.88387 17.7733 7.79664 17.8127 7.70497 17.8127C7.43065 17.8127 7.28437 17.4893 7.46551 17.2833L10.9172 13.3577L11.0989 13.1508Z",
      fill: t
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M15.9405 7.8125C16.215 7.8125 16.3613 8.13614 16.18 8.34223L12.9314 12.035L12.7501 12.2408C12.6134 12.396 12.3675 12.3826 12.2485 12.2134C12.1635 12.0925 12.1724 11.929 12.2701 11.8181L12.553 11.497L15.0685 8.63513L15.7017 7.92004C15.7622 7.85165 15.8492 7.8125 15.9405 7.8125Z",
      fill: t
    }
  )
] }), _1 = ({ width: e = 24, height: r = 25, fill: t = "currentColor" }) => /* @__PURE__ */ p("svg", { width: e, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.8125H16.504C18.987 3.8125 21 5.8255 21 8.3085V17.3175C21 19.7995 18.987 21.8125 16.504 21.8125H7.496C5.013 21.8125 3 19.7995 3 17.3165V8.3125C3 5.8275 5.015 3.8125 7.5 3.8125V3.8125Z",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ o("path", { d: "M8.12109 11.9121V17.3121", stroke: t, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M11.7188 17.3121V14.1621C11.7188 12.9191 12.7257 11.9121 13.9688 11.9121C15.2118 11.9121 16.2188 12.9191 16.2188 14.1621V17.3121",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M8.11854 8.65039C7.99454 8.65039 7.89354 8.75139 7.89454 8.87539C7.89454 8.99939 7.99554 9.10039 8.11954 9.10039C8.24354 9.10039 8.34454 8.99939 8.34454 8.87539C8.34454 8.75039 8.24354 8.65039 8.11854 8.65039",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), L1 = ({ width: e = 24, height: r = 25, fill: t = "currentColor" }) => /* @__PURE__ */ p("svg", { width: e, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.8125H16.504C18.987 3.8125 21 5.8255 21 8.3085V17.3175C21 19.7995 18.987 21.8125 16.504 21.8125H7.496C5.013 21.8125 3 19.7995 3 17.3165V8.3125C3 5.8275 5.015 3.8125 7.5 3.8125V3.8125Z",
      stroke: t,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ o("g", { clipPath: "url(#clip0_28489_2660)", children: /* @__PURE__ */ o(
    "path",
    {
      d: "M12.595 11.1565C12.9199 11.3116 13.2029 11.5425 13.4201 11.8296C13.6373 12.1168 13.7824 12.4519 13.8432 12.8067C13.9041 13.1616 13.8789 13.5259 13.7697 13.869C13.6606 14.2121 13.4707 14.524 13.216 14.7785L10.966 17.0285C10.5441 17.4505 9.97175 17.6875 9.37501 17.6875C8.77827 17.6875 8.20597 17.4505 7.78401 17.0285C7.36205 16.6066 7.125 16.0343 7.125 15.4375C7.125 14.8408 7.36205 14.2685 7.78401 13.8465L8.66251 12.968M15.3375 12.657L16.216 11.7785C16.638 11.3566 16.875 10.7843 16.875 10.1875C16.875 9.59077 16.638 9.01847 16.216 8.59651C15.7941 8.17455 15.2218 7.9375 14.625 7.9375C14.0283 7.9375 13.456 8.17455 13.034 8.59651L10.784 10.8465C10.5293 11.101 10.3394 11.4129 10.2303 11.756C10.1212 12.0991 10.096 12.4634 10.1568 12.8183C10.2176 13.1732 10.3628 13.5082 10.58 13.7954C10.7972 14.0825 11.0801 14.3134 11.405 14.4685",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) }),
  /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "clip0_28489_2660", children: /* @__PURE__ */ o("rect", { width: "12", height: "12", fill: "white", transform: "translate(6 6.8125)" }) }) })
] }), C1 = "SharePostLinks-module_wrapper__hsjUF", f1 = "SharePostLinks-module_shareTitle__xybHC", k1 = "SharePostLinks-module_copyIcon__6i1wT", w1 = "SharePostLinks-module_copied__fVesg", f = {
  wrapper: C1,
  shareTitle: f1,
  copyIcon: k1,
  copied: w1
}, g1 = [
  {
    href: (e) => `https://www.facebook.com/sharer/sharer.php?u=${e}`,
    label: "Share on Facebook",
    Icon: m1
  },
  {
    href: (e) => `https://twitter.com/intent/tweet?url=${e}`,
    label: "Share on Twitter",
    Icon: h1
  },
  {
    href: (e) => `https://www.linkedin.com/shareArticle?mini=true&url=${e}`,
    label: "Share on LinkedIn",
    Icon: _1
  }
];
function y() {
  return typeof window < "u" ? window.location.origin + window.location.pathname : "";
}
function P1({ className: e }) {
  const [r, t] = w(!1), [s, c] = w(""), n = b(async () => {
    const l = y();
    try {
      await navigator.clipboard.writeText(l), t(!0), setTimeout(() => t(!1), 2e3);
    } catch (i) {
      console.error("Failed to copy the link. Please try again or copy it manually.", i);
    }
  }, []);
  if (g(() => {
    c(y());
  }, []), !s) return null;
  const a = encodeURIComponent(s);
  return /* @__PURE__ */ p("div", { className: d(f.wrapper, "text text-sm", e), children: [
    /* @__PURE__ */ o("p", { className: f.shareTitle, children: "Share" }),
    g1.map(({ href: l, label: i, Icon: m }) => /* @__PURE__ */ o("a", { href: l(a), target: "_blank", rel: "noopener noreferrer", "aria-label": i, children: /* @__PURE__ */ o(m, {}) }, i)),
    /* @__PURE__ */ o(
      "button",
      {
        className: d(f.copyIcon, { [f.copied]: r }),
        "data-tooltip": r && "Link Copied",
        onClick: n,
        children: /* @__PURE__ */ o(L1, {})
      }
    )
  ] });
}
export {
  q1 as Button,
  J1 as CloseBtn,
  Y1 as CopyLink,
  D1 as DataLayer,
  F1 as FormControl,
  U1 as I18nLink,
  E1 as Input,
  O1 as Loader,
  A1 as ModalWrapper,
  G1 as Row,
  P1 as SharePostLinks,
  N1 as Stamp,
  X1 as TableOfContents,
  B1 as Text,
  Q1 as VideoEmbed
};
//# sourceMappingURL=components.js.map
